/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.5",
    versionName: "0.2.0-nightly.2026.2.5",
    versionChannel: "nightly",
    buildDate: "2026-02-05T00:10:19.372Z",
    commitHash: "fe7e0890148a48962b81978402f745d17e668d3b",
};
